import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getRouteToCarouselItem(
  item: CarouselItem,
  type?: LibraryType,
): string {
  if (item.type === 'theme' && !type) {
    throw new Error(
      "The 'type' parameter is required when the item's type is 'theme'.",
    );
  }

  if ('url' in item) {
    return item.url;
  }

  switch (type) {
    case 'overlay':
    case 'widget':
      return `/library/items/${item.theme_id}`;
  }

  throw new Error('No URL or type provided for the carousel item.');
}

export function getRouteToItem(
  item?: LibraryItem | CarouselItem,
  type?: LibraryType,
) {
  if (!item) {
    return '/library';
  }

  if ('url' in item) {
    return item.url;
  }

  if ('theme_id' in item && type) {
    switch (type) {
      case 'overlay':
        return `/library/items/${item.theme_id}`;
      case 'widget':
        return `/library/items/${item.theme_id}`;
    }
  }

  if ('id' in item) {
    return `/library/items/${item.id}`;
  }

  if ('theme_id' in item) {
    return `/library/items/${item.theme_id}`;
  }

  return `/library`;
}
